import "slick-carousel";
import { handleQuickshopModal } from "../modal/handleQuickshopModal";

export const handleProductsSlider = (element) => {
  let $slider = element;

  $slider.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    swipeToSlide: true,
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    draggable: true,
    responsive: [
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  });

  $slider.on("breakpoint", () => {
    handleQuickshopModal();
  });
};

if ($(".related-products").length > 0) {
  handleProductsSlider($(".related-products"));
}
